import SequencedActions from '../utils/SequencedActions';
import SimpleTweenFloat from '../utils/SimpleTweenFloat';

import SlotSymbol from './SlotSymbol';

export default class Reel {
	constructor(scene, reelData, reelNumber, symbolSizeY, windowsCount, randomStartPosition, spinTime, animFrameRate, simpleTweener) {
		this.scene = scene;
		this.reelData = reelData;
		this.symbOrder = reelData.symbolImages;
		this.maskImage = reelData.maskImage;
		this.posX = scene.centerX + reelData.offsetX;
		this.posY = scene.centerY + reelData.offsetY;
		this.reelNumber = reelNumber;
		this.symbolSizeY = symbolSizeY;
		this.symbols = [];
		this.symbolSpites = [];
		this.randomStartPosition = randomStartPosition;
		this.windowsCount = windowsCount;
		this.spinTime = spinTime;
		this.speed = 0;
		this.blur = false;
		this.animFrameRate = animFrameRate;
		this._create();
	}

	_create() {
		this.windowOffsetY = ((this.windowsCount - 1) / 2) * this.symbolSizeY; // 0 window offset
		this.windowPosY = this.posY + this.windowOffsetY; // 0 window position
		this.visibleMaxY = this.getWindowPosition(0).y + this.symbolSizeY * 0.6;
		this.visibleMinY = this.getWindowPosition(this.windowsCount - 1).y - this.symbolSizeY * 0.6;

		this.scene['reel' + this.reelNumber] = this.scene.add.image(this.posX, this.posY, this.reelData.windowImage); // add window image sprite
		this.scene['reel' + this.reelNumber].depth = -3;

		// create geometry mask
		/*
        var shape = this.scene.make.graphics();
        shape.fillStyle(0xffffff);
        shape.beginPath();
        shape.fillRect(this.posX - this.symbolSizeY * 0.6, this.windowPosY + this.symbolSizeY * 0.6,  this.symbolSizeY * 1.2, -this.windowsCount * this.symbolSizeY * 1.2);
        var gMask = shape.createGeometryMask();
        */
		for (var si = 0; si < this.symbOrder.length; si++) {
			var symbName = this.symbOrder[si];
			var posY = this.windowPosY - si * this.symbolSizeY;
			var symbSprite = this.scene.add.image(this.posX, posY, symbName);
			symbSprite.name = symbName; // set name
			//  symbSprite.setMask(gMask);                        // apply mask
			var symbol = new SlotSymbol(this.scene, symbSprite, symbName + 'Blurred', posY, this.animFrameRate);
			this.setIconAndAddAtTop(symbol);
			this.symbols.push(symbol);
			this.symbolSpites.push(symbSprite);
		}

		if (this.symbols.length < this.windowsCount) {
			console.log('Reel ' + this.reelNumber + ': symbols tape size< slot window size, add symbols');
		}

		var invisibleSymbols = this.symbols.length - this.windowsCount;
		this.halfInvis = Math.floor(invisibleSymbols / 2);
		this.minBottomSymbPos = this.windowPosY + this.halfInvis * this.symbolSizeY; //
		this.maxTopSymbPos = this.windowPosY - (this.halfInvis + this.windowsCount - 1) * this.symbolSizeY;
		this.currOrderPosition = 0;
		this.nextOrderPosition = 0;
		this.arrangeBottomTapePart();

		// set random start position
		if (this.randomStartPosition) {
			this.nextOrderPosition = getRandomOrderPosition();
			var distY = this.getDistToNextSymb(this.nextOrderPosition);
			this.symbolsMove(0, distY);
			this.currOrderPosition = this.nextOrderPosition;
			this.arrangeTape();
		}

		this.canSpin = true;

		this.symbols.forEach(s => {
			s.setVisible(s.posY <= this.visibleMaxY && s.posY >= this.visibleMinY);
		});
		this.scene.updateEvent.add(this.update, this);
	}

	spin(
		nextOrderPosition,
		completeCallBack // spin down
	) {
		// var nextOrderPosition = this.getRandomOrderPosition();
		var spinTime = this.spinTime + this.reelData.addSpinTime;
		if (!this.canSpin) return;
		this.canSpin = false;
		var distY = this.getDistToNextSymb(nextOrderPosition);
		var count = distY / this.symbolSizeY;
		count += this.symbols.length;
		var timePS = spinTime / count;
		this.nextOrderPosition = nextOrderPosition;

		var sA = new SequencedActions(); // spin sequence: 1 symbol back -> (main spin + 2 symbols) -> 1 symbol back

		sA.add(callBack => {
			new SimpleTweenFloat(
				this,
				0.0,
				-this.symbolSizeY,
				timePS * 1.5, // 1 symbol back
				(p, dp) => {
					this.symbolsMove(p, dp);
					this.arrangeBottomTapePart();
				},
				() => {
					this.arrangeBottomTapePart();
					this.setBlur(true);
					callBack();
				}
			);
		}, this);

		sA.add(callBack => {
			new SimpleTweenFloat(
				this,
				0.0,
				this.symbolSizeY * (count + 2),
				spinTime, // main spin
				(p, dp) => {
					this.symbolsMove(p, dp);
					this.arrangeTopTapePart();
				},
				() => {
					this.arrangeTopTapePart();
					this.setBlur(false);
					callBack();
				}
			);
		}, this);

		sA.add(callBack => {
			new SimpleTweenFloat(
				this,
				0.0,
				-this.symbolSizeY,
				timePS * 1.5, // 1 symbol back
				(p, dp) => {
					this.symbolsMove(p, dp);
					this.arrangeBottomTapePart();
				},
				() => {
					this.arrangeBottomTapePart();
					this.currOrderPosition = this.nextOrderPosition;
					callBack();
				}
			);
		}, this);

		sA.add(callBack => {
			this.canSpin = true;
			console.log(this.reelNumber + ' - reel spin complete');
			completeCallBack();
			callBack();
		}, this);

		sA.start();
	}

	symbolsMove(posY, dPos) {
		this.symbols.forEach(s => {
			s.setPositionY(s.posY + dPos);
			s.setVisible(s.posY <= this.visibleMaxY && s.posY >= this.visibleMinY);
		});
	}

	getBottomSymbol() {
		// positive axe down
		var symb = this.symbols[0];
		this.symbols.forEach(s => {
			if (s.posY > symb.posY) symb = s;
		});
		return symb;
	}

	getTopSymbol() {
		// positive axe down
		var symb = this.symbols[0];
		this.symbols.forEach(s => {
			if (s.posY < symb.posY) symb = s;
		});
		return symb;
	}

	setIconAndAddAtTop(slotSymbol) {
		var topSymbol = this.getTopSymbol();
		if (topSymbol === slotSymbol) return;

		var symbPosY = topSymbol ? topSymbol.posY - this.symbolSizeY : this.windowPosY;
		var newSymbolOrder = topSymbol ? topSymbol.orderOnReel + 1 : 0;
		if (newSymbolOrder > this.symbOrder.length - 1) newSymbolOrder = 0;
		slotSymbol.setPositionY(symbPosY);
		var symID = this.symbOrder[newSymbolOrder]; // получаем имя символа
		slotSymbol.setIcon(symID);
		slotSymbol.orderOnReel = newSymbolOrder;
	}

	setIconAndAddAtBottom(slotSymbol) {
		var bottomSymbol = this.getBottomSymbol();
		if (bottomSymbol === slotSymbol) return;
		var symbPosY = bottomSymbol ? bottomSymbol.posY + this.symbolSizeY : this.windowPosY;
		var newSymbolOrder = bottomSymbol ? bottomSymbol.orderOnReel - 1 : 0;
		if (newSymbolOrder < 0) newSymbolOrder = this.symbOrder.length - 1;
		slotSymbol.setPositionY(symbPosY);
		var symID = this.symbOrder[newSymbolOrder]; // получаем имя символа
		slotSymbol.setIcon(symID);
		slotSymbol.orderOnReel = newSymbolOrder;
		//  if(this.reelNumber == 0) console.log('slotSymbol:' + slotSymbol.sprite.name + '; posY: ' + slotSymbol.posY + '; order: ' + slotSymbol.orderOnReel);
	}

	//arrange tape symbols above and below the window
	arrangeTape() {
		this.arrangeBottomTapePart();
		this.arrangeTopTapePart();
	}

	arrangeBottomTapePart() {
		// control bottom
		var botSymbol = this.getBottomSymbol();
		var botPosY = botSymbol.posY;
		var delta = -botPosY + this.minBottomSymbPos;
		if (delta > 0) {
			var sCount = Math.round(delta / this.symbolSizeY);
			for (var i = 0; i < sCount; i++) {
				var topSymbol = this.getTopSymbol();
				this.setIconAndAddAtBottom(topSymbol);
			}
		}
	}

	arrangeTopTapePart() {
		// control top
		var topSymbol = this.getTopSymbol();
		var topPosY = topSymbol.posY;
		var delta = -this.maxTopSymbPos + topPosY;
		if (delta > 0) {
			var sCount = Math.round(delta / this.symbolSizeY);
			for (var i = 0; i < sCount; i++) {
				var botSymbol = this.getBottomSymbol();
				this.setIconAndAddAtTop(botSymbol);
			}
		}
	}

	// return symbols from windows
	getWindowsSymbols(orderPosition) {
		var vSymbols = [];
		for (var si = 0; si < this.windowsCount; si++) {
			var order = orderPosition + si;
			if (order > this.symbols.length - 1) {
				order = order % this.symbols.length;
			}
			vSymbols.push(this.symbols[order]);
			// console.log(this.reelNumber + ':' + this.symbols[order].sprite.name);
		}
		return vSymbols;
	}

	findWindowsSymbols(spriteName) {
		var vSymbols = this.getWindowsSymbols(this.currOrderPosition);
		var found = [];
		vSymbols.forEach(s => {
			if (s.sprite.name === spriteName) finded.push(s);
		});
		return found;
	}

	getDistToNextSymb(nextOrderPosition) {
		if (this.currOrderPosition < nextOrderPosition) {
			return (nextOrderPosition - this.currOrderPosition) * this.symbolSizeY;
		}
		return (this.symbOrder.length - this.currOrderPosition + nextOrderPosition) * this.symbolSizeY;
	}

	getRandomOrderPosition() {
		return Phaser.Math.Between(0, this.symbols.length - 1);
	}

	getWindowPosition(windowNumber) {
		return new Phaser.Math.Vector2(this.posX, this.windowPosY - windowNumber * this.symbolSizeY);
	}

	getWindowSymbol(windowNumber) {
		var wSymbols = this.getWindowsSymbols(this.currOrderPosition);
		return wSymbols[windowNumber];
	}

	setBlur(blur) {
		if (this.blur === blur) return;
		this.blur = blur;
		this.symbols.forEach(s => {
			s.setBlur(blur);
		});
	}
}
